import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { UserServiceService } from "../user-service.service";
import { ToastService } from "../toast.service";
import { Router } from "@angular/router";
import { LazyImgDirective } from "../lazy-img.directive";
import { FormsModule } from "@angular/forms";
import { MatFormField , MatLabel} from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { MatCard } from "@angular/material/card";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-forgot-password-new",
  templateUrl: "./forgot-password-new.component.html",
  styleUrls: ["./forgot-password-new.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LazyImgDirective, FormsModule, MatFormField, MatLabel, MatInput, MatButton, MatCard, RouterLink]
})
export class ForgotPasswordNewComponent implements OnInit {
  model: any = {};

  constructor(
    private userService: UserServiceService,
    private router: Router,
    private toast: ToastService
  ) {}

  ngOnInit(): void {}

  login() {
    this.userService.forgetPassword(this.model.user_id).subscribe(
      data => {
        console.log(data);
        if (data["success"]) {
          this.toast.success(data["message"] || "Reset link sent to your email");
          this.router.navigate(["/login-page"]);
        } else {
          this.toast.error(data["message"] || "Could not send reset link");
        }
      },
      error => {
        console.log(error);
        this.toast.error("Something went wrong. Please try again.");
      }
    );
  }
}
